import React, { useState, useEffect } from "react"
import axios from "axios"
import { Card, CardBody, Col, Container, Row, Table, Badge } from "reactstrap"
import moment from "moment"
import { getCurrentAcadid } from "store/Common/Actions"
import { useDispatch, useSelector } from "react-redux"
import Spinners from "components/Common/Spinner"
import { toast } from "react-toastify"

const LeaveReport = () => {
  const [data, setData] = useState(null)

  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const [leaveStatus, setLeaveStatus] = useState("-1")
  const [isSubmit, setIsSubmit] = useState(false)

  const { acadID } = useSelector(state => state.CommonReducer)
  const token = JSON.parse(localStorage.getItem("Token"))

  const getLeaveTitle = async () => {
    setLoading(true)
    try {
      await axios({
        method: "POST",
        url: "https://marcopolo.prisms.in/api/leave/get-leave-history",
        data: {
          leave_status: leaveStatus,
          acadId: acadID.acadid,
        },
        headers: {
          Authorization: token,
        },
      }).then(res => {
        setData(res.data)
        setLoading(false)
      })
    } catch (error) {
      console.error("Error fetching leave data:", error)
      setLoading(false)
    }
  }

  useEffect(() => {
    if (localStorage.getItem("sid")) {
      dispatch(
        getCurrentAcadid({
          sid: localStorage.getItem("sid"),
        })
      )
    }
  }, [dispatch])

  useEffect(() => {
    if (isSubmit || (leaveStatus && acadID.acadid)) {
      getLeaveTitle()
    }
  }, [leaveStatus, acadID.acadid, isSubmit])

  const handleChange = e => {
    setLeaveStatus(e.target.value)
  }
  const options = [
    "Pending",
    "Approved L1",
    "Approved L2",
    "Reject",
    "Cancelled",
  ]

  const handleUpdateStatus = async id => {
    try {
      setLoading(true)
      setIsSubmit(false)
      await axios({
        method: "POST",
        url: "https://marcopolo.prisms.in/api/LeaveList/update-leave-status-staff",
        data: {
          leave_request_id: id,
          status: "Cancelled",
          status_reason: "",
        },
        headers: {
          Authorization: token,
        },
      }).then(res => {
        setLoading(false)
        setIsSubmit(true)
        toast.success(res.data.message)
      })
    } catch (error) {
      setLoading(false)
      setIsSubmit(false)

      toast.success("something went wrong")
    }
  }
  return (
    <Row className="mt-5 py-4">
      <div className="container-fluid">
        <Container>
          <Card>
            <CardBody>
              <h1 className="text-center mt-2 mb-4 fs-4">Leave History</h1>
              <Row>
                <Col xl="4" className="mt-1">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={handleChange}
                  >
                    <option value="-1">Select All</option>
                    <option value="Rejected">Rejected</option>
                    <option value="Pending">Pending</option>
                    <option value="Cancelled">Approved</option>
                  </select>
                </Col>
              </Row>
              {loading ? (
                <Spinners />
              ) : data && data.data && data.data.length > 0 ? (
                <div className="mt-4">
                  {data.data.map(person => (
                    <Card key={person.req_id} className="mb-3 shadow-sm">
                      <CardBody>
                        <h5 className="fw-medium fs-6 mb-3 text-primary">
                          {person.first_name + " " + person.last_name}
                        </h5>

                        <Row className="mb-2">
                          <Col xs="6" md="4">
                            <strong>Leave Type:</strong> {person.lname}
                          </Col>
                          <Col xs="6" md="4">
                            <strong>Applied:</strong>{" "}
                            {moment(person.created_date).format("DD/MM/YYYY")}
                          </Col>
                        </Row>

                        <Row className="mt-2">
                          <Col xs="6" md="4">
                            <strong>Start:</strong>{" "}
                            {moment(person.start_date).format("DD/MM/YYYY")}
                          </Col>
                          <Col xs="6" md="4">
                            <strong>End:</strong>{" "}
                            {moment(person.end_date).format("DD/MM/YYYY")}
                          </Col>
                          <Col xs="6" md="4" className="d-flex mt-2">
                            <strong className="me-1">Status:</strong>
                            <span>{person.req_status}</span>
                          </Col>
                          <Col xs="6" md="4" className="d-flex mt-2">
                            <strong className="me-1">Count:</strong>
                            <span>{person.leave_count}</span>
                          </Col>
                        </Row>

                        {person.req_status === "Pending" && (
                          <Col
                            xs="6"
                            md="4"
                            className="d-flex align-items-center mt-2"
                          >
                            <strong className="me-2">Cancel Leave:</strong>
                            <Badge color="danger" onClick={() => handleUpdateStatus(person.req_id)}>submit</Badge>
                          </Col>
                        )}

                        <Row>
                          <Col xs="12" className="mt-2">
                            <strong>Reason:</strong> {person.reason}
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  ))}
                </div>
              ) : (
                <div className="text-center mt-4">No data available</div>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </Row>
  )
}

export default LeaveReport

{
  /* <span
                              className={
                                person.req_status === "Rejected"
                                  ? "text-danger fw-medium"
                                  : person.req_status === "Approved"
                                  ? "text-success fw-medium"
                                  : person.req_status === "Pending"
                                  ? "text-warning fw-medium"
                                  : ""
                              }
                            >
                              {person.req_status}
                            </span> */
}
